import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { ctaTriggerAndNavigate } from '@/helpers/ctaTriggerAndNavigate';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

export const clickCtaAction = () => {
  const buttons = document.querySelectorAll('.ctaFrame');
  buttons.forEach((ctaButton) => {
    ctaButton.addEventListener('click', (e) => {
      e.stopPropagation();
      let contents = navigateMediaItem();
      if (!window.storeeelItems.isMobile && window.storeeelItems.frame == 'square') {
        if (window.moviePosition != 0 && contents == false) {
          contents = window.storeeelItems.contentGroups[window.moviePosition].contents;
          window.moviePosition = 0;
        }
      }
      const currentMedia = contents[window.moviePosition];
      const ctaUrl = currentMedia.ctaLink;

      // CTAイベントを計測
      trackCtaClick(currentMedia);
      setLocalStorage(currentMedia);

      ctaTriggerAndNavigate(ctaUrl)
    });
  });
};

function trackCtaClick(currentMedia) {
  trackStoreeelEvent('storeeel_cta_click', {
    'storeeel_name': currentMedia.mediaAsset.name,
    'media_id': currentMedia.mediaAsset.id,
    'campaign_id': window.storeeelItems.id,
  });
}

function setLocalStorage(currentMedia) {
  localStorageRepositories.get("ctaClick").set(
    currentMedia.mediaAsset.id,
    window.storeeelItems.id
  );
}
